import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import { tabletStyles } from '../../../../../components/shared/table/table.styles'
import Search from '../../../../../components/shared/search/search.component'
import { tableTabletFilterStyles } from './table-tablet-filter.styles'
import { FILTER_MODES, SERVER_SIDE_SEARCH_DEBOUNCE_VALUE } from '../../table.constants'

const TableTabletSearchInput = ({
  handleGlobalFilter,
  searchPlaceholder,
  initialValue,
  setPage,
  isSearchDisabled,
  searchEndAdornment,
  hasToolbarWithBorder,
  hasTabletTableView,
  searchSlot,
  onKeyDown,
  onSearchIconClick,
  onClearSearchRef,
  searchIconPosition,
  filterMode,
}) => {
  const onChange = useCallback(
    (value) => {
      handleGlobalFilter(value || '')
      setPage?.(0)
    },
    [handleGlobalFilter, setPage]
  )

  return (
    <Box
      sx={[
        tabletStyles.tabletFilterContainer,
        tableTabletFilterStyles.container({ hasToolbarWithBorder, hasTabletTableView }),
      ]}
    >
      <Box sx={tabletStyles.searchContainer}>
        <Search
          searchCallback={onChange}
          placeholder={searchPlaceholder}
          debounceValue={
            filterMode === FILTER_MODES.SERVER_SIDE ? SERVER_SIDE_SEARCH_DEBOUNCE_VALUE : 300
          }
          initialValue={initialValue}
          isDisabled={isSearchDisabled}
          searchIconPosition={searchIconPosition || 'end'}
          onKeyDown={onKeyDown}
          onSearchIconClick={onSearchIconClick}
          onClear={onClearSearchRef}
          endAdornment={searchEndAdornment || searchSlot}
        />
      </Box>
    </Box>
  )
}

TableTabletSearchInput.propTypes = {
  searchPlaceholder: PropTypes.string,
  initialValue: PropTypes.string,
  handleGlobalFilter: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  isSearchDisabled: PropTypes.bool,
  hasToolbarWithBorder: PropTypes.bool,
  hasTabletTableView: PropTypes.bool,
  searchEndAdornment: PropTypes.node,
  searchSlot: PropTypes.node,
  onKeyDown: PropTypes.func,
  onSearchIconClick: PropTypes.func,
  onClearSearchRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.func }),
  ]),
  searchIconPosition: PropTypes.oneOf(['start', 'end']),
  filterMode: PropTypes.string,
}

export default TableTabletSearchInput
